<template>
    <div v-if="selectedCondition" class="condition-modal">
        <div class="flex flex-col items-start">
            <button
                type="button"
                @click="closeModal"
                class="flex items-center ml-auto"
            >
                <span class="mr-2">{{ "map.close" | trans }}</span>
                <inline-svg
                    name="map/map-delete"
                    classes="map-delete"
                ></inline-svg>
            </button>
            <h3
                class="text-xl my-2"
                v-text="selectedCondition.highway.name"
            ></h3>
            <span
                :class="[
                    'px-3 py-2 event-badge font-medium text-sm',
                    selectedCondition.event_or_works_class
                ]"
                v-text="
                    selectedCondition.is_road_work
                        ? 'Radovi'
                        : selectedCondition.breaking_event.name
                "
            ></span>

            <span
                class="text-sm font-medium mt-2"
                v-text="selectedCondition.event_datetime"
            ></span>

            <p
                class="mt-2 font-light text-gray-700 text-sm"
                v-text="selectedCondition.remark"
            ></p>

            <div
                class="flex flex-col items-start mt-3"
                v-if="selectedCondition.weather_id"
            >
                <span class="text-sm font-medium">Meteorološki uvjeti:</span>
                <span
                    class="block my-1 text-sm font-light text-gray-700"
                    v-text="selectedCondition.weather_one.name"
                ></span>
                <inline-svg
                    :name="
                        `icons-weather/${selectedCondition.weather_one.code}`
                    "
                ></inline-svg>
            </div>
            <div
                class="flex flex-col items-start mt-3"
                v-if="selectedCondition.passability_id"
            >
                <span class="text-sm font-medium">Stanje i prohodnost:</span>
                <span
                    class="block my-1 text-sm font-light text-gray-700"
                    v-text="selectedCondition.passability_one.name"
                ></span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import inlineSvg from "./../inlineSvg.js";

export default {
    components: {
        inlineSvg
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters(["selectedCondition"])
    },

    methods: {
        closeModal() {
            // Closes the modal / sets the selected condition to null
            this.$store.commit("setData", {
                name: "selectedCondition",
                data: null
            });
        }
    }
};
</script>
